import React, { useEffect } from 'react';
import { commonStatus } from '@constants';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, NumericField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Card, Col, Row } from 'antd';

const SERVER_ID_MAX_LENGTH = 20;

const ServerProviderForm = (props) => {
    const translate = useTranslate();
    const { formId, actions, dataDetail, onSubmit, setIsChangedFormValues, isEditing } = props;

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const handleSubmit = (values) => {
        return mixinFuncs.handleSubmit({
            ...values,
            maxTenant: Number(values.maxTenant),
            status: commonStatus.ACTIVE,
        });
    };

    useEffect(() => {
        form.setFieldsValue(dataDetail);
    }, [dataDetail]);

    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField required label={translate.formatMessage(commonMessage.name)} name="name" />
                    </Col>
                    <Col span={12}>
                        <TextField
                            required
                            label={translate.formatMessage(commonMessage.serverId)}
                            name="serverId"
                            disabled={isEditing}
                            maxLength={SERVER_ID_MAX_LENGTH}
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField required label={translate.formatMessage(commonMessage.apiUrl)} name="url" />
                    </Col>
                    <Col span={12}>
                        <NumericField
                            required
                            label={translate.formatMessage(commonMessage.maxTenant)}
                            name="maxTenant"
                            min={1}
                            width="100%"
                        />
                    </Col>
                </Row>

                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default ServerProviderForm;
